(function () {
'use strict';
var doc = document, root = doc.documentElement, body = doc.body;
var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
var finePointer = window.matchMedia('(pointer: fine)').matches;
var $ = function (s, c) { return (c || doc).querySelector(s); };
var $$ = function (s, c) { return Array.prototype.slice.call((c || doc).querySelectorAll(s)); };
var moneyFormat = (window.theme && window.theme.moneyFormat) || '${{amount}}';
function money(cents) {
var v = (cents / 100).toFixed(2);
var withComma = v.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
if (k === 'amount_no_decimals') return withComma.split('.')[0];
if (k === 'amount_with_comma_separator') return v.replace('.', ',');
return withComma;
});
}
var ticking = false;
function onScroll() {
if (ticking) return; ticking = true;
requestAnimationFrame(function () {
var y = window.scrollY || 0, h = root.scrollHeight - window.innerHeight;
body.classList.toggle('mm-scrolled', y > 12);
root.style.setProperty('--mm-progress', h > 0 ? (y / h).toFixed(4) : 0);
parallax();
ticking = false;
});
}
window.addEventListener('scroll', onScroll, { passive: true });
var plx = [];
function parallax() {
if (reduce) return;
for (var i = 0; i < plx.length; i++) {
var el = plx[i], r = el.getBoundingClientRect();
if (r.bottom < -200 || r.top > window.innerHeight + 200) continue;
var speed = parseFloat(el.getAttribute('data-mm-parallax')) || 0.15;
var offset = (r.top + r.height / 2 - window.innerHeight / 2) * -speed;
el.style.transform = 'translate3d(0,' + offset.toFixed(1) + 'px,0)';
}
}
function split(el) {
if (el.dataset.mmSplitDone) return; el.dataset.mmSplitDone = '1';
var i = 0;
function walk(node) {
Array.prototype.slice.call(node.childNodes).forEach(function (n) {
if (n.nodeType === 3) {
var frag = doc.createDocumentFragment();
n.textContent.split(/(\s+)/).forEach(function (part) {
if (!part) return;
if (/^\s+$/.test(part)) { frag.appendChild(doc.createTextNode(part)); return; }
var w = doc.createElement('span'); w.className = 'mm-w';
var inner = doc.createElement('span'); inner.textContent = part; inner.style.setProperty('--i', i++);
w.appendChild(inner); frag.appendChild(w);
});
n.parentNode.replaceChild(frag, n);
} else if (n.nodeType === 1 && n.tagName !== 'BR') { walk(n); }
});
}
walk(el); el.classList.add('mm-split');
}
var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
entries.forEach(function (e) {
if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
});
}, { rootMargin: '0px 0px -4% 0px', threshold: 0.05 }) : null;
function reveal(el) { if (io && !reduce) io.observe(el); else el.classList.add('is-in'); }
function autoReveal(scope) {
var sel = [
'.main-content .section-header', '.main-content .product-item-block', '.main-content .feature-row',
'.main-content .icon-with-text--block', '.main-content .collection-grid-item', '.main-content .article_block',
'.main-content .rich-text__wrapper', '.site-footer__item'
].join(',');
$$(sel, scope).forEach(function (el, idx) {
if (el.closest('[data-mm-reveal]') || el.classList.contains('mm-auto-reveal')) return;
el.classList.add('mm-auto-reveal');
el.style.setProperty('--d', ((idx % 4) * 70) + 'ms');
reveal(el);
});
}
function counter(el) {
var end = parseFloat(el.getAttribute('data-mm-count')) || 0, dur = 1400, start = null;
var suffix = el.getAttribute('data-suffix') || '';
if (reduce) { el.textContent = end + suffix; return; }
var cio = new IntersectionObserver(function (es) {
if (!es[0].isIntersecting) return; cio.disconnect();
function step(t) {
if (!start) start = t; var p = Math.min((t - start) / dur, 1);
var eased = 1 - Math.pow(1 - p, 4);
el.textContent = Math.round(end * eased) + suffix;
if (p < 1) requestAnimationFrame(step);
}
requestAnimationFrame(step);
}, { threshold: 0.5 });
cio.observe(el);
}
function magnetic(el) {
if (!finePointer || reduce) return;
el.addEventListener('pointermove', function (e) {
var r = el.getBoundingClientRect(), x = e.clientX - r.left, y = e.clientY - r.top;
el.style.setProperty('--bx', x + 'px'); el.style.setProperty('--by', y + 'px');
el.style.transform = 'translate(' + ((x - r.width / 2) * 0.12).toFixed(1) + 'px,' + ((y - r.height / 2) * 0.22).toFixed(1) + 'px)';
});
el.addEventListener('pointerleave', function () { el.style.transform = ''; });
}
function tilt(el) {
if (!finePointer || reduce) return;
var max = parseFloat(el.getAttribute('data-mm-tilt')) || 8;
var host = el.closest('[data-mm-tilt-host]') || el;
host.addEventListener('pointermove', function (e) {
var r = host.getBoundingClientRect();
var px = (e.clientX - r.left) / r.width - 0.5, py = (e.clientY - r.top) / r.height - 0.5;
el.style.transform = 'rotateY(' + (px * max).toFixed(2) + 'deg) rotateX(' + (-py * max).toFixed(2) + 'deg)';
});
host.addEventListener('pointerleave', function () { el.style.transform = ''; });
}
function hero(el) {
if (finePointer && !reduce) {
el.addEventListener('pointermove', function (e) {
var r = el.getBoundingClientRect();
el.style.setProperty('--mx', (e.clientX - r.left) + 'px');
el.style.setProperty('--my', (e.clientY - r.top) + 'px');
});
}
var swatches = $$('[data-mm-hero-swatch]', el), imgs = $$('[data-mm-hero-img]', el);
var priceEl = $('[data-mm-hero-price]', el), cmpEl = $('[data-mm-hero-compare]', el), saveEl = $('[data-mm-hero-save]', el);
var linkEls = $$('[data-mm-hero-link]', el), active = 0, timer;
function show(i) {
active = i;
swatches.forEach(function (s, k) { s.classList.toggle('is-active', k === i); s.setAttribute('aria-pressed', k === i); });
imgs.forEach(function (im, k) { im.classList.toggle('is-out', k !== i); });
var s = swatches[i]; if (!s) return;
if (priceEl && s.dataset.price) priceEl.textContent = s.dataset.price;
if (cmpEl) cmpEl.textContent = s.dataset.compare || '';
if (saveEl) { saveEl.textContent = s.dataset.save || ''; saveEl.hidden = !s.dataset.save; }
linkEls.forEach(function (a) { if (s.dataset.url) a.setAttribute('href', s.dataset.url); });
}
swatches.forEach(function (s, i) {
s.addEventListener('click', function () { clearInterval(timer); show(i); });
});
if (swatches.length) show(0);
if (swatches.length > 1 && !reduce) {
timer = setInterval(function () { show((active + 1) % swatches.length); }, 4200);
el.addEventListener('pointerenter', function () { clearInterval(timer); }, { once: true });
}
}
function openCart() {
try {
if (window.theme && theme.Cart && theme.Cart.prototype && typeof theme.Cart.prototype._onProductAdded === 'function') {
theme.Cart.prototype._onProductAdded();
} else { window.location.href = (window.routes && window.routes.cartUrl) || '/cart'; return; }
} catch (e) { window.location.href = '/cart'; return; }
var cartBtn = $('#HeaderCart');
if (cartBtn) { cartBtn.classList.remove('mm-bump'); void cartBtn.offsetWidth; cartBtn.classList.add('mm-bump'); }
refreshCartCount();
}
function refreshCartCount() {
fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
$$('.header_cart_count, [data-cart-count]').forEach(function (el) { el.textContent = c.item_count; });
$$('.cart_total_info [data-cart-total], .cart_total_info .cart_total_price').forEach(function (el) { el.textContent = money(c.total_price); });
}).catch(function () {});
}
function addToCart(id, qty) {
return fetch('/cart/add.js', {
method: 'POST', credentials: 'same-origin',
headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
body: JSON.stringify({ items: [{ id: Number(id), quantity: qty || 1 }] })
}).then(function (r) {
return r.json().then(function (j) { if (!r.ok) throw j; return j; });
});
}
function busy(btn, state) {
btn.classList.toggle('is-loading', state === 'loading');
btn.classList.toggle('is-added', state === 'added');
}
function builder(el) {
var data; try { data = JSON.parse($('script[type="application/json"]', el).textContent); } catch (e) { return; }
var variants = data.variants, opts = data.options; if (!variants || !variants.length) return;
var state = [];
var first = variants.filter(function (v) { return v.available; })[0] || variants[0];
state = first.options.slice();
var img = $('[data-mm-b-img]', el), visual = $('[data-mm-b-visual]', el);
var priceEl = $('[data-mm-b-price]', el), compareEl = $('[data-mm-b-compare]', el), saveEl = $('[data-mm-b-save]', el);
var stockEl = $('[data-mm-b-stock]', el), btn = $('[data-mm-b-add]', el), btnLabel = $('[data-mm-b-label]', el);
var link = $('[data-mm-b-link]', el);
function find(o) { return variants.filter(function (v) { return v.options.every(function (x, i) { return x === o[i]; }); })[0]; }
function availableWith(idx, value) {
return variants.some(function (v) {
if (v.options[idx] !== value || !v.available) return false;
for (var i = 0; i < idx; i++) if (v.options[i] !== state[i]) return false;
return true;
});
}
function render(swap) {
$$('[data-mm-opt]', el).forEach(function (group) {
var idx = Number(group.getAttribute('data-mm-opt'));
var current = $('[data-mm-opt-current]', group); if (current) current.textContent = state[idx];
$$('[data-value]', group).forEach(function (chip) {
var val = chip.getAttribute('data-value');
chip.classList.toggle('is-active', val === state[idx]);
chip.setAttribute('aria-pressed', val === state[idx]);
var ok = idx === 0 ? variants.some(function (v) { return v.options[0] === val && v.available; }) : availableWith(idx, val);
chip.classList.toggle('is-unavailable', !ok);
});
});
var v = find(state);
if (!v) return;
if (priceEl) priceEl.textContent = money(v.price);
if (compareEl) { compareEl.textContent = v.compare_at_price > v.price ? money(v.compare_at_price) : ''; }
if (saveEl) {
if (v.compare_at_price > v.price) { saveEl.hidden = false; saveEl.textContent = 'Save ' + money(v.compare_at_price - v.price); }
else saveEl.hidden = true;
}
if (stockEl) {
stockEl.classList.remove('is-low', 'is-out');
if (!v.available) { stockEl.textContent = 'Sold out in this size — try another'; stockEl.classList.add('is-out'); }
else if (v.low) { stockEl.textContent = 'Only ' + v.low + ' left in ' + state.join(' / '); stockEl.classList.add('is-low'); }
else { stockEl.textContent = 'In stock — ready to ship'; }
}
if (btn) {
btn.disabled = !v.available; btn.classList.toggle('is-disabled', !v.available);
if (btnLabel) btnLabel.textContent = v.available ? 'Add to cart — ' + money(v.price) : 'Sold out';
btn.setAttribute('data-variant', v.id);
}
if (link) link.setAttribute('href', data.url + '?variant=' + v.id);
if (img && v.image && img.getAttribute('src') !== v.image) {
if (swap && !reduce) {
img.classList.add('is-swapping');
setTimeout(function () { img.src = v.image; img.srcset = ''; img.onload = function () { img.classList.remove('is-swapping'); }; }, 220);
} else { img.src = v.image; img.srcset = ''; }
}
if (visual && v.options[0]) visual.setAttribute('data-word', v.options[0]);
}
$$('[data-mm-opt]', el).forEach(function (group) {
var idx = Number(group.getAttribute('data-mm-opt'));
group.addEventListener('click', function (e) {
var chip = e.target.closest('[data-value]'); if (!chip) return;
state[idx] = chip.getAttribute('data-value');
if (!find(state) || !find(state).available) {
for (var j = idx + 1; j < state.length; j++) {
var vals = opts[j].values;
for (var k = 0; k < vals.length; k++) { if (availableWith(j, vals[k])) { state[j] = vals[k]; break; } }
}
}
render(idx === 0);
});
});
if (btn) btn.addEventListener('click', function () {
var id = btn.getAttribute('data-variant'); if (!id) return;
busy(btn, 'loading');
addToCart(id, 1).then(function () {
busy(btn, 'added'); if (btnLabel) btnLabel.textContent = 'Added ✓';
openCart();
setTimeout(function () { busy(btn, null); render(false); }, 1800);
}).catch(function (err) {
busy(btn, null);
if (stockEl) { stockEl.textContent = (err && err.description) || 'Could not add — please try again'; stockEl.classList.add('is-out'); }
});
});
render(false);
}
doc.addEventListener('click', function (e) {
var b = e.target.closest('[data-mm-quickadd]'); if (!b) return;
e.preventDefault(); e.stopPropagation();
b.classList.add('is-loading');
addToCart(b.getAttribute('data-mm-quickadd'), 1).then(function () {
b.classList.remove('is-loading'); b.classList.add('is-added');
var t = b.textContent; b.textContent = '✓';
openCart();
setTimeout(function () { b.classList.remove('is-added'); b.textContent = t; }, 1600);
}).catch(function () { b.classList.remove('is-loading'); window.location.href = b.getAttribute('data-url') || '/cart'; });
});
function tech(el) {
var spots = $$('[data-mm-spot]', el), items = $$('[data-mm-tech-item]', el), cur = 0, timer;
function go(i) {
cur = i;
spots.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
items.forEach(function (it, k) { it.classList.toggle('is-active', k === i); it.setAttribute('aria-expanded', k === i); });
}
function stop() { clearInterval(timer); }
spots.forEach(function (s, i) { s.addEventListener('click', function () { stop(); go(i); }); s.addEventListener('mouseenter', function () { stop(); go(i); }); });
items.forEach(function (it, i) { it.addEventListener('click', function () { stop(); go(i); }); });
go(0);
if (!reduce && items.length > 1) {
var tio = new IntersectionObserver(function (es) {
if (es[0].isIntersecting) { stop(); timer = setInterval(function () { go((cur + 1) % items.length); }, 3800); }
else stop();
}, { threshold: 0.4 });
tio.observe(el);
el.addEventListener('pointerdown', stop);
}
}
function rail(wrap) {
var track = $('[data-mm-rail-track]', wrap) || wrap; if (!track) return;
var prog = $('[data-mm-rail-progress] i', wrap);
var prev = $('[data-mm-rail-prev]', wrap), next = $('[data-mm-rail-next]', wrap);
function step() { var c = track.firstElementChild; return c ? c.getBoundingClientRect().width + 16 : 300; }
if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
function upd() {
if (!prog) return;
var max = track.scrollWidth - track.clientWidth, ratio = track.clientWidth / track.scrollWidth;
var w = Math.max(ratio * 100, 8);
prog.style.setProperty('--w', w + '%');
prog.style.setProperty('--x', (max > 0 ? (track.scrollLeft / max) * ((100 - w) / w) * 100 : 0) + '%');
}
track.addEventListener('scroll', upd, { passive: true }); window.addEventListener('resize', upd); upd();
if (!finePointer) return;
var down = false, sx = 0, sl = 0, moved = false;
track.addEventListener('pointerdown', function (e) { if (e.button !== 0) return; down = true; moved = false; sx = e.clientX; sl = track.scrollLeft; });
window.addEventListener('pointermove', function (e) {
if (!down) return; var dx = e.clientX - sx;
if (Math.abs(dx) > 6) { moved = true; track.classList.add('is-dragging'); }
track.scrollLeft = sl - dx;
});
window.addEventListener('pointerup', function () { if (!down) return; down = false; setTimeout(function () { track.classList.remove('is-dragging'); }, 0); });
track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
}
function sticky() {
var bar = $('[data-mm-sticky]'); if (!bar) return;
var form = $('.section-product-template form[action*="/cart/add"]') || $('form[action*="/cart/add"][data-product-form]');
var mainBtn = form && form.querySelector('.product-form__cart-submit');
var go = $('[data-mm-sticky-btn]', bar), label = $('[data-mm-sticky-label]', bar);
var vEl = $('[data-mm-sticky-variant]', bar), pEl = $('[data-mm-sticky-price]', bar);
if (!mainBtn) { bar.remove(); return; }
var sio = new IntersectionObserver(function (es) {
var r = es[0].boundingClientRect;
bar.classList.toggle('is-visible', !es[0].isIntersecting && r.top < 0);
});
sio.observe(mainBtn);
function sync(variant) {
if (!variant) return;
if (vEl) vEl.textContent = variant.title === 'Default Title' ? '' : variant.title;
if (pEl) pEl.textContent = money(variant.price);
if (label) label.textContent = variant.available ? 'Add to cart' : 'Sold out';
go.disabled = !variant.available; go.classList.toggle('is-disabled', !variant.available);
}
var section = form.closest('[data-section-type], .shopify-section') || doc;
section.addEventListener('variantChange', function (e) { sync(e.detail && e.detail.variant); });
go.addEventListener('click', function () {
var r = mainBtn.getBoundingClientRect();
if (mainBtn.disabled) { window.scrollTo({ top: window.scrollY + r.top - 160, behavior: 'smooth' }); return; }
busy(go, 'loading');
var input = form.querySelector('[name="id"]');
var qty = form.querySelector('[name="quantity"]');
addToCart(input.value, qty ? parseInt(qty.value, 10) || 1 : 1).then(function () {
busy(go, 'added'); if (label) label.textContent = 'Added ✓'; openCart();
setTimeout(function () { busy(go, null); if (label) label.textContent = 'Add to cart'; }, 1800);
}).catch(function () { busy(go, null); window.scrollTo({ top: window.scrollY + r.top - 160, behavior: 'smooth' }); });
});
}
function shipBars(scope) {
$$('[data-mm-ship]', scope).forEach(function (bar) {
var pct = Math.max(0, Math.min(100, parseFloat(bar.getAttribute('data-mm-ship')) || 0));
var fill = bar.querySelector('.mm-ship-bar__fill');
requestAnimationFrame(function () { requestAnimationFrame(function () { if (fill) fill.style.setProperty('--mm-ship', pct + '%'); }); });
bar.classList.toggle('is-done', pct >= 100);
});
}
function init(scope) {
scope = scope || doc;
$$('[data-mm-split]', scope).forEach(function (el) { split(el); reveal(el); });
$$('[data-mm-reveal]', scope).forEach(reveal);
$$('[data-mm-count]', scope).forEach(counter);
$$('.mm-btn, [data-mm-magnetic]', scope).forEach(magnetic);
$$('[data-mm-tilt]', scope).forEach(tilt);
$$('[data-mm-hero]', scope).forEach(hero);
$$('[data-mm-builder]', scope).forEach(builder);
$$('[data-mm-tech]', scope).forEach(tech);
$$('[data-mm-rail]', scope).forEach(rail);
plx = $$('[data-mm-parallax]');
shipBars(scope);
autoReveal(scope);
onScroll();
}
function boot() {
init(doc); sticky();
var drawer = $('#sidebar-cart');
if (drawer && 'MutationObserver' in window) {
new MutationObserver(function () { shipBars(drawer); }).observe(drawer, { childList: true, subtree: true });
}
}
if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', boot); else boot();
doc.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();